export const TALENT_TABS = ['all', 'profile', 'career', 'activity'] as const

export type TalentTab = (typeof TALENT_TABS)[number]
